import mixPanelService from "./trackers/mixpanel";
export var AVAILABLE_TRACKERS = {
    mixpanel: "mixpanel"
};
var setup = function (env) {
    mixPanelService.setup(env);
};
var getTrackerByName = function (name) {
    switch (name) {
        case AVAILABLE_TRACKERS.mixpanel:
            return mixPanelService.getTracker();
        default:
            return null;
    }
};
export default {
    setup: setup,
    getTrackerByName: getTrackerByName
};
